import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 7a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4l0 -10","key":"svg-0"}],["path",{"d":"M12 7l0 4","key":"svg-1"}]]

/**
 * IconMouse
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbW91c2UiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgN2E0IDQgMCAwIDEgNCAtNGg0YTQgNCAwIDAgMSA0IDR2MTBhNCA0IDAgMCAxIC00IDRoLTRhNCA0IDAgMCAxIC00IC00bDAgLTEwIiAvPgogIDxwYXRoIGQ9Ik0xMiA3bDAgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/mouse
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMouse = createReactComponent('outline', 'mouse', 'Mouse', __iconNode);

export default IconMouse;